import { render, staticRenderFns } from "./next_review.vue?vue&type=template&id=684afa74&scoped=true&"
import script from "./next_review.vue?vue&type=script&lang=js&"
export * from "./next_review.vue?vue&type=script&lang=js&"
import style0 from "./next_review.vue?vue&type=style&index=0&id=684afa74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684afa74",
  null
  
)

export default component.exports